import { Helmet } from 'react-helmet-async';
import { PAGE_ROUTE } from '~/constants';
import ErrorImage from '~/assets/img/completion_images/404.png';
import * as S from './index.styled';

export default function NotFound() {
  const handleHomeClick = () => {
    window.location.href = PAGE_ROUTE.MAIN;
  };

  return (
    <>
      <Helmet>
        <title>404 Not Found</title>
      </Helmet>

      <S.Container>
        <S.InfoBox>
          <img src={ErrorImage} alt={'404_error_image'} />
          <p>Page not found</p>
        </S.InfoBox>
        <S.ButtonBox>
          <S.Button onClick={handleHomeClick}>Go home</S.Button>
        </S.ButtonBox>
      </S.Container>
    </>
  );
}
